export default __webpack_public_path__ + "static/coinsOffered-fa89ea561d73d4614af4da5e8f78c77f.svg";